
const config = {
  apiEndpoint: process.env.REACT_APP_API_ENDPOINT || "http://localhost:7190",
  functionKey: process.env.REACT_APP_FUNCTION_KEY || "",
  teamsResource: process.env.clientId || "api://localhost:53000/67902ea6-7c57-4105-a4b8-e8a8366110bc/access_as_user"
};

export default config;
